export default "<router-outlet ngxUiLoaderBlurred blur=\"10\"></router-outlet>\n<ngx-ui-loader></ngx-ui-loader>\n"